export const IModifier = {
  id: 2,
  name: 'name2-2',
  description: 'description',
  min_selection: 2,
  max_selection: 3,
  allergens: 'no alergen',
  is_active: true,
  ord: 1,
  id2: '',
  id2_type: 0,
  id2_updated_at: '2023-10-19T21:04:55.665Z',
  last_user_id: 32,
  created_at: '2023-10-19T21:04:55.665Z',
  updated_at: '2023-10-19T21:10:08.462Z',
  is_archive: true,
  archived_at: '2023-10-19T21:10:08.462Z',
}

export const IModifierItem = {
  id: 24,
  category_id: 15,
  name: 'Modifier 4 - i 1',
  description: 'this is description',
  min_selection: 1,
  max_selection: 2,
  default_selection: 4,
  allergens: 'no alergen',
  is_active: true,
  ord: 1,
  price: '1.500',
  entity_id: 2,
  entity_type: 3,
  id2: '',
  id2_type: 0,
  id2_updated_at: '2023-11-14T19:37:19.439Z',
  last_user_id: 32,
  created_at: '2023-11-14T19:37:19.439Z',
  updated_at: '2023-11-14T19:37:19.439Z',
  is_archive: false,
  archived_at: null,
}

export const IItemAvailability = { 1: { active: true, av_id: 2 } }

export const IItemSalesTypePrice = { 1: 2.4, 2: 3.2 }

export const IItemTax = { 0: { 1: { active: true, rate: 2.25 } } }

export const IInventoryItemUpsertArgs = {
  _id: 0,
  store_id: 56,
  name: 'Item 11',
  image: '',
  image_type: 0,
  description: 'item description',
  colour: 'FFFFFF',
  is_active: true,
  is_age_restricted: false,
  category_id: 101,
  subcategory_id: 0,
  item_kind: 2,
  item_type_id: 3,
  prep_type: 1,
  prep_time_minute: 90,
  availability_type: 0,
  availability: IItemAvailability,
  price_type: 0,
  default_price: 1.22,
  sales_type_price: IItemSalesTypePrice,
  max_discount_amount: 10,
  plu: 'ppp',
  barcode: 'bbb',
  default_cost: 2.4,
  is_discountable: false,
  is_refundable: false,
  modifiers: [1, 4],
  item_tax_type: 0,
  item_tax: IItemTax,
  purchase_unit: 1,
  inventory_unit: 2,
  sell_unit: 3,
  convert_pi_purchase: 1,
  convert_pi_inventory: 2,
  convert_is_inventory: 3,
  convert_is_sell: 4,
  print_name: 'prnt name',
  second_printer_override: 2,
  ord: 123,
  show_in_pos: true,
  min_qty_sellable: 1,
  max_qty_sellable: 2,
  min_alert_qty: 3,
  daily_qty_available: 4,
  allergen: 'alergennnn',
  item_tags: [1, 2],
  calories_count: 1,
  calories_qty: 2,
  calories_unit: 3,
}

export const IInventoryItem = {
  id: 291,
  name: 'Item 11',
  images: '',
  image_type: 0,
  description: 'item description',
  colour: 'FFFFFF',
  is_age_restricted: false,
  item_kind: 2,
  item_type_id: 3,
  prep_type: 1,
  prep_time_minute: 90,
  plu: 'ppp',
  barcode: 'bbb',
  default_cost: '2.400',
  is_discountable: false,
  is_refundable: false,
  modifiers: [1, 4],
  item_tax_type: 0,
  item_tax: IItemTax,
  purchase_unit: 3,
  inventory_unit: 3,
  sell_unit: 3,
  convert_pi_purchase: '1.000',
  convert_pi_inventory: '2.000',
  convert_is_inventory: '3.000',
  convert_is_sell: '4.000',
  print_name: 'prnt name',
  show_in_pos: true,
  min_qty_sellable: '1.000',
  max_qty_sellable: '2.000',
  min_alert_qty: '3.000',
  custom_fields: {},
  allergen: 'alergennnn',
  item_tags: [1, 2],
  calories_count: 1,
  calories_qty: '2.000',
  calories_unit: 3,
  multilingual_names: {},
  ingredients: {},
  category_id: 0,
  subcategory_id: 0,
  is_archive: false,
  store_id: 56,
  override_is_active: true,
  override_category_id: 101,
  override_subcategory_id: 0,
  availability_type: 0,
  availability: IItemAvailability,
  default_price: '1.220',
  price_type: 0,
  sales_type_price: IItemSalesTypePrice,
  max_discount_amount: '0.000',
  second_printer_override: 2,
  ord: 123,
  daily_qty_available: '4.000',
  override_is_archive: false,
}

export const IInventorySelectItem = {
  category_id: 103,
  category_name: 'Bakery Items',
  item_id: 277,
  item_name: 'Bagels',
  item_kind: [3],
  purchase_unit: 1,
  inventory_unit: 7,
  sell_unit: 1,
  default_price: '2.374',
  inventory_unit_name: 'Liter',
}

export const IModifierCategoryUpsertArgs = {
  id: 2,
  name: 'name2-2',
  description: 'description',
  is_active: true,
  ord: 1,
  min_selection: 2,
  max_selection: 3,
  allergens: 'no alergen',
}

export const IModifierItemUpsertArgs = {
  id: 2,
  name: 'Modifier item 3',
  description: 'this is description',
  is_active: true,
  ord: 1,
  min_selection: 2,
  max_selection: 3,
  default_selection: 4,
  allergens: 'no alergen',
  category_id: 1,
  price: 1.5,
  entity_id: 2,
  entity_type: 3,
}

export const IModifierEntityUpsertArgs = {
  ...IModifierCategoryUpsertArgs,
  items: [{ ...IModifierItemUpsertArgs }],
}
export const IInventoryItemView = {
  ...IInventoryItem,
  purchase_unit_str: 'Item',
  inventory_unit_str: 'Kilogram',
  sell_unit_str: 'Item',
  item_type_str: 'item Type2',
  item_tags_data: [{ colour: '#AA4A9B', id: 10, name: 'purple' }],
  sales_type_price_date: { 'In Store': 10 },
  modifier_data: {
    count: 0,
    list: [{ ...IModifier, items: [IModifierItem] }],
    page: 1,
    total_pages: 1,
  },
  ingredient_data: [{ item_name: 'Lettuce', qty: 1, unit: 'Item' }],
}
